import { TypedJsonResponse, useTypedActionData } from "remix-typedjson";
import { ApiBindingsT, RouteError } from "../route-helpers.server.ts";

export function useResult<
  T extends (
    ..._: any[]
  ) => Promise<
    TypedJsonResponse<
      { confirmation: unknown } | {
        errors: RouteError[];
      }
    >
  >,
>() {
  const data = useTypedActionData<T>();

  if (!data) {
    return { errors: [], confirmation: null };
  }

  if ("errors" in data) {
    return { errors: data.errors, confirmation: null };
  }

  type U = ReturnType<T> extends Promise<
    TypedJsonResponse<{ confirmation: infer U } | { errors: RouteError[] }>
  > ? U
    : never;
  return { errors: [], confirmation: data.confirmation as U };
}
